// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___37HoU","logo":"styles-module__logo___3OoYP"};